import { Flag, Baby, Footprints, Award, MapPin } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader, CTAButton } from "../components/Bits";
import { Reveal } from "../components/Reveal";
import { SCHEDULE, EVENT, LINKS } from "../lib/site";

const icons = [Flag, Baby, Footprints, Award];

export default function Schedule() {
  return (
    <>
      <Seo title="Race Day Schedule" path="/schedule" description="Bib pickup 7:30 AM, Kids 1 km Dash 8:45 AM, 5 km Run/Walk 9:00 AM, Awards 10:30 AM." />
      <PageHeader
        chapter="race day"
        title="The full run of the morning."
        sub={`Saturday, ${EVENT.dateLabel} at ${EVENT.location.name}, ${EVENT.location.address}.`}
      />

      <section className="mx-auto max-w-4xl px-5 sm:px-8 pb-16">
        <div className="relative">
          <div className="absolute left-[27px] sm:left-1/2 top-2 bottom-2 w-px bg-ink/15" />
          {SCHEDULE.map((s, i) => {
            const Icon = icons[i];
            const left = i % 2 === 0;
            return (
              <Reveal key={s.title} delay={i * 0.05}>
                <div className={`relative flex items-start gap-6 mb-10 sm:mb-14 sm:w-1/2 ${left ? "" : "sm:ml-auto sm:flex-row-reverse sm:text-right"}`}>
                  <div className={`z-10 grid place-items-center h-14 w-14 shrink-0 rounded-full bg-terracotta text-white shadow-warm ${left ? "sm:-mr-7 sm:order-last" : "sm:-ml-7"}`} style={left ? { transform: "translateX(0)" } : {}}>
                    <Icon size={22} />
                  </div>
                  <div className="flex-1 rounded-2xl bg-white border border-black/5 p-6 shadow-warm">
                    <p className="font-display text-3xl font-semibold text-terracotta">{s.time}</p>
                    <h3 className="mt-1 font-semibold text-lg">{s.title}</h3>
                    <p className="mt-2 text-sm text-ink-soft leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 sm:pb-32">
        <Reveal>
          <div className="rounded-3xl bg-forest text-cream px-8 py-12 sm:px-14 sm:py-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="flex items-center gap-2 text-ochre font-accent text-2xl"><MapPin size={18} /> {EVENT.location.name}</p>
              <p className="mt-1 text-cream/80">{EVENT.location.address}</p>
            </div>
            <CTAButton href={LINKS.register}>Register for the trot</CTAButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
